<template>
    <div v-if="templateCount" class="rounded-6 overflow-hidden border border-primary-20">
        <draggable-transition-group
            :draggable="!disableMove"
            :disable-delete="disableDelete"
            :enable-duplicate="!disableDuplicate"
            label="name"
            :loading="working"
            :options="templates"
            translatable
            @editing="edit($event)"
            @duplicating="duplicate($event)"
            @deleting="confirmDelete($event)"
            @updateOrder="handleSort"
            @updateOptions="templates = $event"
        />
    </div>
    <div v-else>
        <loading v-if="working" class="pt-24" size="medium"></loading>
        <empty-state
            v-else-if="useEmptyState"
            :button-text="$t('settings.add_new', {subject: $t('settings.email-templates.template')})"
            :description="$t('settings.email-templates.empty_state')"
            :show-animation="false"
            button-icon="add-circle"
            @click="$emit('create')"
        />
    </div>
</template>


<script>

import SvgIcon from './ui/SvgIcon.vue';
import * as templates from '../services/EmailTemplateService';
import {ADD_NOTIFICATION} from '../state/mutation-types';
import {mapState, mapActions} from 'pinia';
import {useMainStore} from '../state/store';
import {useNotificationsStore} from '../state/modules/notifications';
import EmptyState from './ui/EmptyState.vue';
import Loading from './ui/Loading.vue';
import DraggableTransitionGroup from "./ui/DraggableTransitionGroup.vue";

export default {
    components: {
        DraggableTransitionGroup,
        Loading,
        EmptyState,
        'svg-icon': SvgIcon,
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        value: {
            required: true,
        },
        working: Boolean,
        useEmptyState: {
            type: Boolean,
            default: false,
        },
        disableDuplicate: {
            type: Boolean,
            default: false,
        },
        disableDelete: {
            type: Boolean,
            default: false,
        },
        disableMove: {
            type: Boolean,
            default: false,
        },
        context: {
            type: String,
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'locale']),
        active_locale() {
            return this.currentCompany.jobsite.active_languages.includes(this.locale) ? this.locale : this.currentCompany.jobsite.active_languages[0];
        },
        templates: {
            get() {
                return this.value;
            },
            set(templates) {
                this.$emit('change', templates);
            },
        },
        templateCount() {
            return this.templates.length;
        },
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        duplicate(template) {
            this.$emit('duplicate', template);
        },
        edit(template) {
            this.$emit('edit', template);
        },
        confirmDelete(template) {
            this.$emit('delete', template);
        },
        handleSort({evt, item, done}) {
            if (evt.oldIndex === evt.newIndex) return;
            templates.updateOrder(evt.oldIndex, evt.newIndex, this.context).then(response => {
                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: response.data.message,
                });
            }).then(() => done()).catch(error => {
                this[ADD_NOTIFICATION]({
                    type: 'error',
                    message: error.message,
                });
            });
        },
    },
};
</script>
